import React, { Component } from 'react';
import { Form, Button, Row } from 'react-bootstrap';

import ComboFilter from './GridFilter/ComboFilter';
import DateFilter from './GridFilter/DateFilter';
import DateIntervalFilter from './GridFilter/DateIntervalFilter';
import MapFilter from './GridFilter/MapFilter';
import NumericFilter from './GridFilter/NumericFilter';
import TextFilter from './GridFilter/TextFilter';

import NumFilter from './GridFilter/NumFilter';



/**
* Class GridFilter
* Generic component to generate grid filters
**/
class GridFilter extends Component {
  /**
  * props
  * title : title of the grid
  * objectClass : reference name prefix
  * filters : filter list
  * parent : the parent reference
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {hidden: false};
	}

  /**
  * render
  * Rendering component function : display the filter form
  **/
  render() {
    // Filters rendering
    const filters = this.getFilters();

    // Form rendering
    if(this.props.asForm === false) {
      return(
        <div className="listFilterContainer">
          <h4 className="gridTitle" onClick={this.props.hiddable === true ? this.showFilters.bind(this) : null}>
            {this.props.title}
            {this.props.hiddable === true ? <span className={"glyphicon glyphicon-chevron-" + (this.state.hidden === false ? "down" : "right")}></span> : null}
          </h4>
          {this.state.hidden === false ?
            <div ref={"formFilter" + this.props.objectClass}>
              {filters}
              <Button className="reinitBtn" bsStyle="default" onClick={this.resetForm.bind(this)}>Réinitialiser</Button>
            </div> : null
          }
        </div>
      );
    } else {
      let formProps = {
        ref : "formFilter" + this.props.objectClass
      };

      if(this.props.formattedFilters !== true) formProps.horizontal = true;

      return(
        <div className="listFilterContainer">
          <h4 className="gridTitle" onClick={this.props.hiddable === true ? this.showFilters.bind(this) : null}>
            {this.props.title}
            {this.props.hiddable === true ? <span className={"glyphicon glyphicon-chevron-" + (this.state.hidden === false ? "down" : "right")}></span> : null}
          </h4>
          {this.state.hidden === false ?
            <Form {...formProps}>
              {filters}
              <Row><Button className="reinitBtn" bsStyle="default" onClick={this.resetForm.bind(this)}>Réinitialiser</Button></Row>
            </Form> : null
          }
        </div>
      );
    }
  }

  /**
  * showFilters
  * Manage filters visilibity
  **/
  showFilters() {
    let state = this.state;
    state.hidden = !state.hidden;
    this.setState(state);
  }

  /**
  * handleChange
  * Modify the state of the filter from a filter field change
  **/
  handleChange(filterField, value) {
    this.props.parent.applyFilter(filterField.props.name, value);
  }

  handleNumChange(filterField, values) {
    this.props.parent.applyNumFilter(filterField.props.name, values);
  }


  /**
  * handleNumericChange
  * Modify the state of the filter from a filter field change
  **/
  handleNumericChange(filterField, values) {
    this.props.parent.applyNumericFilter(filterField.props.name, values);
  }

  /**
  * handleDateIntervalChange
  * Modify the state of the filter from a filter field change
  **/
  handleDateIntervalChange(filterField, values) {
    this.props.parent.applyDateIntervalFilter(filterField.props.name, values);
  }

  /**
  * handleArrayChange
  * Modify the state of the filter from a filter field change
  **/
  handleArrayChange(filterField, value) {
    this.props.parent.applyArrayFilter(filterField.props.name, value);
  }

  /**
  * handleObjectChange
  * Modify the state of the filter from a filter field change
  **/
  handleObjectChange(filterField, value, idField) {
    this.props.parent.applyObjectFilter(filterField.props.name, value, idField);
  }

  /**
  * handleDateChange
  * Modify the state of the filter from a date filter field change
  **/
  handleDateChange(filterField, dateValue, comparatorValue) {
    // Filter the grid's table
    this.props.parent.applyDateFilter("table" + this.props.objectClass + filterField.props.name, dateValue, comparatorValue);
  }

  /**
  * resetForm
  * Reset the form and the filters
  **/
  resetForm() {
    for(const key in this.refs) {
      if(this.refs.hasOwnProperty(key) && typeof this.refs[key].reset === "function") {
        this.refs[key].reset();
      }
    }

    this.props.parent.clearFilters();
  }

  getFilters() {
    const filters = this.props.filters.map(filter => {
      let component = undefined;
      const key = filter.type + filter.name + this.props.objectClass;

      let props = {
        ref: filter.name,
        key : key,
        title : filter.title,
        name : filter.name,
        isArray : filter.isArray === true,
        isObject : filter.isObject === true,
        parentFilter : this,
        rowIdx: filter.rowIdx
      };

      switch (filter.type) {
        case "date":
          if(filter.default !== undefined) {
            props.default = filter.default;
          }
          props.forceSelection = true;

          component = <DateFilter {...props} />;
          break;

        case "dateinterval":
          component = <DateIntervalFilter {...props} />;
          break;

        case "numeric":
          component = <NumericFilter {...props} />;
          break;

        case "combo":
          if(filter.default !== undefined) {
            props.default = filter.default;
          }
          props = { ...props, ...filter,
            forceSelection: true
          };
          component = <ComboFilter {...props} />;
          break;

        case "map":
          props.layer = filter.layer;
          component = <MapFilter {...props} />
          break;

        case "num":
          component = <NumFilter {...props} />;
          break;

        case "text":
        default:
          component = <TextFilter {...props} />;
          break;


      }

      return component;
    });

    if(this.props.formattedFilters === true) {
      let formattedFilters = [];
      filters.forEach((filter) => {
        if(!(formattedFilters[filter.props.rowIdx] instanceof Array)) formattedFilters[filter.props.rowIdx] = [];
        formattedFilters[filter.props.rowIdx].push(filter);
      });

      formattedFilters = formattedFilters.map((row, idx) => {
        return <Row key={idx}>{row}</Row>;
      });

      return formattedFilters;
    }

    return filters;
  };

}

export default GridFilter;



// WEBPACK FOOTER //
// ./src/views/Helper/GridFilter.js